<router-outlet></router-outlet>
<app-global-toast></app-global-toast>
<app-connection-overlay
  [isVisible]="(healthService.isBackendDown$ | async) ?? false"
  [isReconnecting]="(healthService.isReconnecting$ | async) ?? false"
></app-connection-overlay>
